function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 380"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 379",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 432",
  d: "M14.613 9.18a5.859 5.859 0 01-.7-2.759A5.978 5.978 0 0119.726.5a5.9 5.9 0 015.4 8.455 3.74 3.74 0 00-.188 2.976l.048.123"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 433",
  d: "M34.494 4.765a5.335 5.335 0 01-1.824 8.553 3.28 3.28 0 00-2.088 2.973v.149"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 434",
  d: "M25.704 6.276a5.34 5.34 0 016.449-2.975"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 435",
  d: "M28.864 10.757a3.153 3.153 0 00-3.154-3.154"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 436",
  d: "M19.719 9.947a3.651 3.651 0 00-5.106-.766"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 437",
  d: "M11.125 7.465a3.651 3.651 0 00-3.651 3.651"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 438",
  d: "M9.883 17.512a3.636 3.636 0 00-2.269-.789"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 439",
  d: "M18.28 18.166a3.652 3.652 0 00-4.469-2.594"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 440",
  d: "M25.583 19.013a3.652 3.652 0 00-5.149-.4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 441",
  d: "M34.332 18.638a3.652 3.652 0 00-3.179-4.069"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 442",
  d: "M4.646 11.008a5.9 5.9 0 017.274-6.98"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 443",
  d: "M1.488 19.432a5.3 5.3 0 01-.849-1.948 5.464 5.464 0 015.332-6.644 2.923 2.923 0 011.924.538 5.625 5.625 0 003.214 1.277l.812.036"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 444",
  d: "M10.467 19.389a5.465 5.465 0 01-5.733 2.229 5.192 5.192 0 01-.881-.278"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 445",
  d: "M27.114 22.27a5.459 5.459 0 01-9.444-1.917 2.215 2.215 0 01.61-2.187 4.336 4.336 0 001.242-3.6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 446",
  d: "M18.212 21.579a5.456 5.456 0 01-8.022-6.444"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 447",
  d: "M39.045 22.46a8.077 8.077 0 01-13.551-3.769 6.168 6.168 0 00-2.1-3.418l-.353-.277"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 448",
  d: "M35.879 9.091a8.077 8.077 0 014.9 10.8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 449",
  d: "M25.26 26.591c.126 1.482 1.921 3.712 3.726 5.608a1.8 1.8 0 003.109-1.383c-.24-2.873-.163-5.931 1.24-5.991"
})));

function SvgBraininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.91,
    height: 33.302,
    viewBox: "0 0 41.91 33.302"
  }, props), _ref);
}

export default SvgBraininline;